import cx from "classnames";

import {
  MILLISECONDS_PER_DAY,
  MILLISECONDS_PER_SECOND,
  SECONDS_PER_MINUTE,
} from "@util/constants";
import getDataAttributes from "@util/getDataAttributes";
import {
  getElapsedTimeInMilliseconds,
  getStringifiedElapsedTime,
} from "@util/getElapsedTime";
import { TDateISO } from "types/date";

import { TimestampProps } from "./types";

import styles from "./styles.module.css";

const getTimestamp = (timestamp: TDateISO) => {
  const elapsedTime = getElapsedTimeInMilliseconds(timestamp);

  if (elapsedTime < MILLISECONDS_PER_DAY) {
    const stringifiedElapsedTime = getStringifiedElapsedTime(timestamp);

    return `${stringifiedElapsedTime}`;
  }

  const date = new Date(timestamp);

  return date.toLocaleString("default", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export function Component(props: TimestampProps) {
  const { timestamp } = props;

  const millisecondsElapsed = getElapsedTimeInMilliseconds(timestamp);
  const isLessThan30Minutes =
    millisecondsElapsed < MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE * 30;

  return (
    <time
      {...getDataAttributes(props)}
      className={cx([
        styles.timestampContainer,
        { [styles.isLessThan30Minutes]: isLessThan30Minutes },
      ])}
    >
      {getTimestamp(timestamp)}
    </time>
  );
}
Component.displayName = "Timestamp.Component";
